
import cloneDeep from "lodash/cloneDeep";
import { meetingAPI } from "@/api";
import { addSocketMessageListener } from "@/api/socketAPI";
import SocketMessageType from "@/constants/SocketMessageType";
import { store } from "@/store/store";

const updateMeeting = async ( { body, } ) => {
	const { meetingId, outcomeVersion, outcomeId, /* personId, */ } = body;
	if ( !meetingId ) {
		console.warn( "meeting API orchestrator: a meetingId was expected but was not detected" );
		return;
	}
	const options = { version: 2, };
	try {
		if ( outcomeVersion === "v2" ) {
			store.dispatch( "myCommitments/processUpdatedCommitment", { outcomeId, } );
		} else {
			const meeting = await meetingAPI.getMeeting( { meetingId, }, options );
			const clonedMeeting = cloneDeep( meeting );
			store.dispatch( "meeting/processMeetingUpdate", { meeting: clonedMeeting, } );
		}
	} catch ( e ) {
		if ( e.message !== "Meeting not found" ) {
			console.error( "error starting meeting", body, e );
		}
		// TODO: implementation
	}
};

const updateAttendee = async ( { body, } ) => {
	const { meetingId, /* , personId, */ } = body;
	if ( !meetingId ) {
		console.warn( "meeting API orchestrator: a meetingId was expected but was not detected" );
		return;
	}
	try {
		const attendees = await meetingAPI.fetchAttendees( { meetingId, } );
		store.dispatch( "meeting/processAttendeeUpdate", { meetingId, attendees, } );
	} catch ( e ) {
		console.error( "error setting meeting attendees", body, e );
		// TODO: implementation
	}
};

export const initWebSocketListeners = () => {
	// updateAttendee
	addSocketMessageListener( SocketMessageType.ATTENDEE_JOINED, updateAttendee );
	addSocketMessageListener( SocketMessageType.ATTENDEE_LEFT, updateAttendee );

	// updateMeeting
	[
		SocketMessageType.MEETING_UPDATED,
		SocketMessageType.OUTCOME_CREATED,
		SocketMessageType.OUTCOME_DELETED,
		SocketMessageType.OUTCOME_UPDATED,
		SocketMessageType.TOPIC_CREATED,
		SocketMessageType.TOPIC_DEFERRED,
		SocketMessageType.TOPIC_DELETED,
		SocketMessageType.TOPIC_UNDEFERRED,
		SocketMessageType.TOPIC_UPDATED,
	].forEach( messageType => addSocketMessageListener( messageType, updateMeeting ) );
};



// WEBPACK FOOTER //
// ./src/store/modules/meeting/meetingApiOrchestrator.js